import * as React from "react";
import { useCallback, useState } from "react";
import styled from "styled-components";
import { useFormikContext } from "formik";
import { ButtonToolbar, Button, ControlLabel, FormControl, FormGroup } from "components/bootstrap";
import Popover from "components/common/Popover";
import EntityCreateShareFormGroup from "components/permissions/EntityCreateShareFormGroup";
import useSaveViewFormControls from "views/hooks/useSaveViewFormControls";
import Alert from "components/bootstrap/Alert";
import styles from "./SavedSearchForm.css";
const stopEvent = (e) => {
  e.preventDefault();
  e.stopPropagation();
};
const StyledPopoverDropdown = styled(Popover.Dropdown)``;
const SavedSearchForm = ({
  children = void 0,
  show,
  isCreateNew,
  saveSearch,
  saveAsSearch,
  toggleModal,
  value,
  viewId = null,
  selectedStreamGRN = null
}) => {
  const { dirty: formDirty } = useFormikContext();
  const [title, setTitle] = useState(value);
  const [sharePayload, setSharePayload] = useState(null);
  const onChangeTitle = useCallback(
    (e) => setTitle(e.target.value),
    []
  );
  const trimmedTitle = (title != null ? title : "").trim();
  const disableSaveAs = trimmedTitle === "" || !isCreateNew && trimmedTitle === value;
  const createNewTitle = isCreateNew ? "Create new" : "Save as";
  const createNewButtonTitle = isCreateNew ? "Create new search" : "Save as new search";
  const pluggableSaveViewControls = useSaveViewFormControls();
  const _saveSearch = useCallback(() => saveSearch(title, sharePayload), [saveSearch, title, sharePayload]);
  const _saveAsSearch = useCallback(() => saveAsSearch(title, sharePayload), [saveAsSearch, title, sharePayload]);
  return /* @__PURE__ */ React.createElement(Popover, { position: "left", width: 500, opened: show, withArrow: true, withinPortal: true }, /* @__PURE__ */ React.createElement(Popover.Target, null, children), /* @__PURE__ */ React.createElement(StyledPopoverDropdown, { title: "Name of search", id: "saved-search-popover" }, /* @__PURE__ */ React.createElement("form", { onSubmit: stopEvent }, formDirty && /* @__PURE__ */ React.createElement(Alert, { compact: true, noIcon: true, bsStyle: "warning" }, "There are unconfirmed changes to the search parameters (time range, streams, or query). Saving now will discard them. If this is not intentional, execute the search to apply your changes before saving.", " "), /* @__PURE__ */ React.createElement(FormGroup, null, /* @__PURE__ */ React.createElement(ControlLabel, { htmlFor: "title" }, "Title"), /* @__PURE__ */ React.createElement(FormControl, { type: "text", value: title, id: "title", placeholder: "Enter title", onChange: onChangeTitle })), pluggableSaveViewControls == null ? void 0 : pluggableSaveViewControls.map(
    ({ component: Component, id }) => Component && /* @__PURE__ */ React.createElement(Component, { key: id, disabledViewCreation: disableSaveAs })
  ), !disableSaveAs && /* @__PURE__ */ React.createElement(
    EntityCreateShareFormGroup,
    {
      description: "Search for a User or Team to add as collaborator on this search.",
      entityType: "search",
      entityTitle: "",
      entityId: isCreateNew ? null : viewId,
      dependenciesGRN: selectedStreamGRN,
      onSetEntityShare: (payload) => setSharePayload(payload)
    }
  ), /* @__PURE__ */ React.createElement(ButtonToolbar, null, !isCreateNew && /* @__PURE__ */ React.createElement(
    Button,
    {
      bsStyle: "primary",
      className: styles.button,
      type: "submit",
      bsSize: "sm",
      title: "Save search",
      onClick: _saveSearch
    },
    "Save"
  ), /* @__PURE__ */ React.createElement(
    Button,
    {
      disabled: disableSaveAs,
      bsStyle: "info",
      className: styles.button,
      type: "submit",
      bsSize: "sm",
      title: createNewButtonTitle,
      onClick: _saveAsSearch
    },
    createNewTitle
  ), /* @__PURE__ */ React.createElement(Button, { className: styles.button, onClick: toggleModal, bsSize: "sm" }, "Cancel")))));
};
export default SavedSearchForm;
